<template>
    <div class="cooperate-form">
        <div class="content-header">
            <el-table :data="likeMe" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="who邀请我" prop="userNick" width="90"></el-table-column>
                <el-table-column label="邀请时间" prop="createTime" width="150"></el-table-column>
                <el-table-column label="是否接受" prop="relationUserName" width="90">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isAnswer==1" type="success">已接受</el-tag>
                        <el-tag v-else type="danger">未接受</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="来源">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.questionClassId==12" type="success">内部访谈</el-tag>
                        <el-tag v-else type="danger">消费者访谈</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="确认时间">
                    <template slot-scope="scope">
                        <p v-html="scope.row.answerContent" style="text-align: left"></p>
                    </template>
                </el-table-column>
                <el-table-column label="补充内容">
                    <template slot-scope="scope">
                        <p v-html="scope.row.answerContent1" style="text-align: left"></p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="178">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini" @click="getCooperativeQues(scope.row)">查看</el-button>
                        <el-button :disabled="scope.row.isAnswer==1" type="primary" size="mini" @click="showCallbackDialog(scope.row.relationId)">接收访谈</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        :hide-on-single-page="formInline.pageSize>=recordsTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
            <el-drawer
                    title="内容(*必填)"
                    :visible.sync="drawerShow"
                    direction="rtl"
                    :before-close="handleClose" size="70%">
                <div style="padding: 5px 20px;">
                    <template v-for="(item,index) in quesList">
                        <div>
                            <p>
                                <span><b style="color: red">{{item.required==1?'*':''}}</b>{{index+1}} .</span>
                                <span v-html="item.questionName"></span>
                            </p>
                            <p style="font-size: 10px;color:grey" v-html="item.questionDesc"></p>
                            <div>
                                <template v-if="item.questionType==2">
                                    <el-select v-model="item.answer" clearable placeholder="请选择" @change="formSubmit(item)">
                                        <el-option
                                                v-for="opt in JSON.parse(item.questionOption)"
                                                :key="opt.code"
                                                :label="opt.name"
                                                :value="opt.code" :disabled="editIs==0">
                                        </el-option>
                                    </el-select>
                                </template>
                                <template v-else-if="item.questionType==4">
                                    <el-row :gutter="20">
                                        <el-col :sm="10" :xs="24">
                                            <el-select v-model="item.answer"
                                                       filterable
                                                       remote
                                                       clearable
                                                       reserve-keyword
                                                       :remote-method="querySearch"
                                                       @change="formSubmit(item)"
                                                       placeholder="请输入同事姓名或邮箱" :disabled="editIs==0">
                                                <el-option
                                                        v-for="user in selectUserList"
                                                        :key="user.USER_ID"
                                                        :label="user.USER_NAME"
                                                        :value="user.USER_ID">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                        <el-col :sm="12" :xs="20">
                                            <el-input
                                                    type="textarea"
                                                    :rows="2"
                                                    autosize
                                                    placeholder="你想要感谢的是什么"
                                                    @blur="formSubmit(item)"
                                                    v-model="item.answer" :disabled="editIs==0" maxlength="5000" show-word-limit>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else-if="item.questionType==5">
                                    <el-row :gutter="20" v-for="(rel,relIndex) in item.relationEntityList" :key="relIndex" style="margin-bottom: 5px">
                                        <el-col :sm="10" :xs="24">
                                            <el-select v-model="rel.relationUserId"
                                                       filterable
                                                       remote
                                                       clearable
                                                       reserve-keyword
                                                       :remote-method="querySearch1"
                                                       @change="formSubmit(item)"
                                                       @focus="selectFocus(relIndex)"
                                                       ref="select"
                                                       placeholder="请输入同事姓名或邮箱" :disabled="editIs==0">
                                                <template v-if="currentSelectIndex==relIndex">
                                                    <el-option
                                                            v-for="user in selectUserList1"
                                                            :key="user.USER_ID"
                                                            :label="user.USER_NAME"
                                                            :disabled="user.enable==0"
                                                            :value="user.USER_ID">
                                                    </el-option>
                                                </template>
                                                <template v-else>
                                                    <el-option
                                                            v-for="user in userAllList"
                                                            :key="user.USER_ID"
                                                            :label="user.USER_NAME"
                                                            :disabled="user.enable==0"
                                                            :value="user.USER_ID">
                                                    </el-option>
                                                </template>

                                            </el-select>
                                        </el-col>
                                        <el-col :sm="12" :xs="20">
                                            <el-input
                                                    type="textarea"
                                                    :rows="2"
                                                    autosize
                                                    placeholder="你想要感谢的是什么"
                                                    @blur="formSubmit(item)"
                                                    v-model="rel.content" :disabled="editIs==0" maxlength="5000" show-word-limit>
                                            </el-input>
                                        </el-col>
                                        <el-col :sm="2" :xs="4">
                                            <el-button v-if="relIndex==0" :disabled="editIs==0" type="success" icon="el-icon-plus" circle size="small" @click="addQues(item)"></el-button>
                                            <el-button v-else type="danger" :disabled="editIs==0" icon="el-icon-minus" circle size="small" @click="minuQues(item,relIndex)"></el-button>
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else-if="item.questionType==6">
                                    <draggable v-model="item.relationEntityList" @change="changeListSort">
                                        <el-row :gutter="20" v-for="(rel,relIndex) in item.relationEntityList" :key="relIndex" style="margin-bottom: 5px">
                                            <el-col :sm="1">
                                                <span style="position: relative;top:5px;cursor:default">{{relIndex+1}}).</span>
                                            </el-col>
                                            <el-col :sm="21">
                                                <el-input
                                                        type="textarea"
                                                        :rows="2"
                                                        autosize
                                                        placeholder="这周要做的事"
                                                        @blur="formSubmit(item)"
                                                        v-model="rel.content" :disabled="editIs==0" maxlength="5000" show-word-limit>
                                                </el-input>
                                            </el-col>
                                            <el-col :sm="2" v-if="item.checkWeekAfterWeek">
                                                <el-checkbox :disabled="!item.canRated" v-model="rel.finished" :true-label="1" :false-label="2" @change="submitWeekCheck(rel)"></el-checkbox>
                                            </el-col>
                                            <el-col :sm="2" v-else>
                                                <el-button v-if="relIndex==0" :disabled="editIs==0" type="success" icon="el-icon-plus" circle size="small" @click="addQues(item)"></el-button>
                                                <el-button v-else type="danger" :disabled="editIs==0" icon="el-icon-minus" circle size="small" @click="minuQues(item,relIndex)"></el-button>
                                            </el-col>
                                        </el-row>
                                    </draggable>


                                </template>
                                <template v-else-if="item.questionType==7">
                                    <el-table :data="JSON.parse(item.answer.toString())" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                                        <el-table-column label="上月价值创造目标" prop="lastMonthValue"></el-table-column>
                                        <el-table-column label="上月实际价值创造计算" prop="lastMonthFactValue"></el-table-column>
                                        <el-table-column label="下个月价值创造目标" prop="nextMonthValue"></el-table-column>
                                    </el-table>
                                </template>
                                <template v-else-if="item.questionType==8">
                                    <el-input
                                            type="textarea"
                                            :rows="1"
                                            autosize
                                            placeholder=""
                                            v-model="item.answer" :disabled="true" maxlength="5000" show-word-limit>
                                    </el-input>
                                </template>
                                <template v-else-if="item.questionType==9">
                                    <el-checkbox @change="formSubmit(item)"
                                                 v-model="tab.check"
                                                 style="margin-bottom: 10px;margin-left: 0px!important;"
                                                 size="mini" v-for="tab in item.answer"
                                                 :label="tab.name"
                                                 :true-label="1"
                                                 :false-label="0"
                                                 :key="tab.code"
                                                 :disabled="editIs==0"
                                                 border></el-checkbox>
                                </template>
                                <template v-else-if="item.questionType==10">
                                    <template v-for="(supItem,supIndex) in item.subPaperAnswerEditVos">
                                        <div style="margin-left: 20px">
                                            <p>
                                                <span>{{supIndex+1}}) .</span>
                                                <span v-html="supItem.questionName"></span>
                                            </p>
                                            <template v-if="supItem.questionType==9">
                                                <el-checkbox
                                                        v-model="tab.check"
                                                        :true-label="1"
                                                        :false-label="0"
                                                        @change="formSubmit(item)"
                                                        style="margin-bottom: 10px;margin-left: 0px!important;"
                                                        size="mini"
                                                        v-for="tab in supItem.answer"
                                                        :key="tab.code"
                                                        :disabled="editIs==0"
                                                        :label="tab.name" border></el-checkbox>
                                            </template>
                                            <template v-else>
                                                <el-input-number v-model="supItem.answer" @change="formSubmit(item)" :min="0" :max="10" label="请输入内容" :disabled="editIs==0"></el-input-number>
                                            </template>
                                        </div>
                                    </template>
                                </template>
                                <template v-else-if="item.questionType==11">
                                    <el-select v-model="item.answer"
                                               filterable
                                               remote
                                               clearable
                                               reserve-keyword
                                               :remote-method="querySearch"
                                               @change="formSubmit(item)"
                                               placeholder="请输入同事姓名或邮箱" :disabled="editIs==0">
                                        <el-option
                                                v-for="user in selectUserList"
                                                :key="user.USER_ID"
                                                :label="user.USER_NAME"
                                                :value="user.USER_ID">
                                        </el-option>
                                    </el-select>
                                </template>
                                <template v-else>
                                    <el-input
                                            type="textarea"
                                            :rows="2"
                                            autosize
                                            placeholder="请输入内容"
                                            @blur="formSubmit(item)"
                                            v-model="item.answer" :disabled="editIs==0" maxlength="5000" show-word-limit>
                                    </el-input>
                                </template>

                            </div>
                        </div>
                    </template>
                    <div style="text-align: center">
                        <el-button v-if="editIs==1" type="danger" @click="formSubmit('')" :disabled="editIs==0">保存</el-button>
                        <template v-else >
                            <template v-if="formInline.classId==8&&leaderIs">
                                <el-button type="primary" :disabled="reportFinish==0" @click="showDialogLeader=true">leader评价</el-button>
                            </template>
                            <el-button v-if="formInline.classId==1||formInline.classId==2||formInline.classId==2" :disabled="reportFinish==0||voitIs==0" type="primary" @click="showCommentDialog(1)">点赞</el-button>
                            <el-button v-if="formInline.classId==1||formInline.classId==2" type="danger" :disabled="reportFinish==0" @click="showCommentDialog(2)">评论</el-button>

                        </template>
                    </div>

                </div>
            </el-drawer>
            <el-dialog
                    title="确认邀请"
                    :visible.sync="showDialog"
                    width="50%"
                    center
                    @close="closeCallBackDialog">
                <el-input
                        type="textarea"
                        :rows="2"
                        autosize
                        placeholder="你确认的采访日期和时间"
                        v-model="callBackCommitContent" maxlength="5000" show-word-limit>
                </el-input>
                <el-input
                        type="textarea"
                        :rows="2"
                        autosize
                        placeholder="你还想要补充讨论的内容"
                        v-model="callBackCommitContent1" maxlength="5000" show-word-limit>
                </el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" :disabled="callBackCommitContent.length<=0||callBackCommitContent1.length<=0" @click="callBackComment(paperId,periodId)">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                quesList:[],
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:1,
                    ctype:11,
                    isself:0
                },
                likeMe:[],
                recordsTotal:0,
                showDialog:false,
                callBackCommitContent:'',
                callBackCommitContent1:'',
                relationId:'',

                drawerShow:false,
                editIs:0,
                voitIs:0,
                leaderIs:false,
                periodId:'',
                paperId:'',
                fileObjList:[],
                userAllList:[],
                selectUserList1:[],
                selectUserList:[],
                currentSelectIndex:-1,
                dialogType:1,
                likeCommitContent:'',
                showDialogLeader:false,
                reportStatus:0,
                reportFinish:0,
                isNice:0,
                userId:''
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.formInline.classId = this.sectionClassId
            this.getCooperativeCallMe()
        },
        methods: {
            getCooperativeCallMe() {
                this.$store.dispatch('initCooperativeCallMe',this.formInline).then(res=>{
                    this.likeMe = res.list
                    this.recordsTotal = res.total
                })
            },
            getCooperativeAllUserList() {
                this.$store.dispatch('initCooperativeAllUserList',{type:0,classId:''}).then(res=>{
                    this.userAllList = res
                    this.selectUserList1 = res
                    this.selectUserList = res
                })
            },
            getCooperativeQues(obj) {
                this.getCooperativeAllUserList();
                this.drawerShow = true;
                this.voitIs = obj.isVoit;
                this.leaderIs = obj.leader;
                this.periodId = obj.periodId;
                this.paperId = obj.id;
                this.userId = obj.userId;
                this.editIs = 0;
                this.reportStatus= obj.reportStatus;
                this.isNice = obj.isNice;
                this.reportFinish = obj.status;//0未填写 1已填写
                this.$store.dispatch('initCooperativeQues',{classId:obj.questionClassId,paperId:obj.paperId}).then(res=>{
                    this.quesList = res
                    let arr = []
                    this.quesList.map(item=>{
                        if(item.questionType==3){
                            arr = JSON.parse(item.answer||'[]')
                        }
                        if(item.questionType==9){
                            item.answer = JSON.parse(item.answer.toString())
                        }
                        if(item.questionType==10){
                            item.subPaperAnswerEditVos.map(item1=>{
                                if(item1.questionType==9){
                                    item1.answer = JSON.parse(item1.answer.toString())
                                }
                            })

                        }
                    })
                    this.fileObjList = arr.map(item=>{
                        return {name:item.name,url:item.url}
                    })
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeCallMe()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeCallMe()
            },
            callBackComment(){
                this.$store.dispatch('cooperativeCallBack',{relationId:this.relationId,content:this.callBackCommitContent,content1:this.callBackCommitContent1}).then(res=>{
                    this.showDialog = false
                    this.relationId = ''
                    this.getCooperativeCallMe()
                })
            },
            closeCallBackDialog(){
                this.showDialog = false
                this.relationId = ''
            },
            showCallbackDialog(id){
                this.showDialog = true
                this.relationId = id

            },
            handleClose(done) {
                this.quesList=[]
                this.voitIs = 0;
                this.editIs = 0;
                this.periodId = '';
                this.paperId = '';
                this.userId = '';
                this.fileObjList = [];
                this.leaderIs = false;
                this.reportStatus= 0;
                this.isNice = 0;
                this.reportFinish = 0;
                done();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/interviewInviteCall.vue